module.exports = __webpack_public_path__ + "img/walking_in_nature.1a5b8a20.jpg";